/**
 * @fileoverview Simple framework for organizing page specific code.
 */

var $ = require('jquery');
var ads = require('./ads');
var analytics = require('./analytics');
var endless = require('./endless');
var Filmstrip = require('./filmstrip');
var nav = require('./nav');
var carousel = require('./carousel');
var comments = require('./comments');
var newsletterModal = require('./newsletter/modal.js');
var posts = require('./posts');
var util = require('./util');
var historyApi = require('./history');
var vote = require('./vote');

function maybeLoadPlayer() {
  var videoPlayer = $("#inertia-carousel-video-player");
  if (!videoPlayer.length) {
    return;
  }

  function scrollTo(orig, elem, speed) {
    var el = $(orig);
    el.animate({
      scrollTop: el.scrollTop() - el.offset().top + $(elem).offset().top
    }, speed === undefined ? 500 : speed);
  }

  function loadPlayer(player, selectedPlaylist, selectedItem) {
    var playlistItems = $('.inertia-video-playlist').find('li a');

    var metalist = $('meta[name="video-playlist"]').attr('content');
    if (!metalist.length) {
      return;
    }

    var selectVideo = function (index) {
      var PLAYING_CLS = 'inertia-video-playlist-playing';
      playlistItems.removeClass(PLAYING_CLS).eq(index).addClass(PLAYING_CLS);
      scrollTo('.inertia-video-playlist', playlistItems.eq(index));
    };

    var playlist = selectedPlaylist || JSON.parse(metalist).playlist;

    player.on('playlistItem', function (e) {
      selectVideo(e.index);
    });

    player.once('playlist', function () {
      if (selectedItem) {
        var idx = playlist.findIndex(function (p) {
          return p.mediaid === selectedItem;
        });
        player.playlistItem(idx);
        setTimeout(function () {
          player.play();
        }, 250);
      }
    });

    if (player.getPlaylist()) {
      player.load(playlist);
    } else {
      player.setup({playlist: playlist});
    }

    playlistItems.on('click', function (e) {
      e.preventDefault();

      var selectedId = $(this).data('mediaid');
      var idx = playlist.findIndex(function (p) {
        return p.mediaid === selectedId;
      });
      player.playlistItem(idx);
    });

    return player;
  }

  function unloadPlayer(player) {
    var playlistItems = $('.inertia-video-playlist').find('li a');
    playlistItems.off('click');
    player.off('playlistItem');
  }

  function setupPlaylistLoading(done) {
    $('.inertia-video-link').click(function (e) {
      e.preventDefault();

      var $el = $(this);
      var playlistData = $el.closest('section').data('playlist');
      var mediaid = $el.data('mediaid');

      var thumbs = playlistData.playlist.map(function (i) {
        return '<li><a data-mediaid=""><img src="' + i.image + '"><span>' + i.title + '</span></a></li>';
      });
      $('.inertia-video-playlist').html('<ol class="list-unstyled">' + thumbs.join('') + '</ol>');

      $('html, body').scrollTop($('.inertia-video-playlist').offset().top);

      done(playlistData.playlist, mediaid);
    });
  }

  var player;
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://content.jwplatform.com/libraries/sD62Ayf8.js';
  s.onload = function() {
    player = jwplayer('inertia-carousel-video-player');
    loadPlayer(player);
    setupPlaylistLoading(function (playlist, mediaid) {
      unloadPlayer(player);
      loadPlayer(player, playlist, mediaid);
    });
  };
  document.body.appendChild(s);
}

var timeout = null;
function thumbTimer($images, idx) {
  var len = $images.length;
  $images.removeClass('item-desc-thumbs-vis').hide();

  if (idx === len-1) {
    idx = 0;
  } else {
    idx++;
  }

  $images.eq(idx).addClass('item-desc-thumbs-vis').fadeIn(500);

  if (!idx) {
    return null;
  }

  return setTimeout(function (img, i) {
    clearTimeout(timeout);
    timeout = null;
    timeout = thumbTimer(img, i);
  }, 1200, $images, idx);
}

var pages = {
  /**
   * Category pages.
   */
  category: function(baseUrl, isMobile, extra) {
    var maxScrolls = 30;
    var fetchedDocs = 1;
    /*
    endless.scrollerRecent(baseUrl, maxScrolls, fetchedDocs, {
      category: extra.categoryId,
      curated_list: $('.inertia-cat-curate').length > 0
    });
    */

    $('.inertia-video-filmstrip').each(function () {
      new Filmstrip(this, '.inertia-video-filmstrip-inner > div');
    });

    maybeLoadPlayer();

    var offset = 6;
    $('.inertia-load-more').click(function () {
      var $button = $(this);
      var originalText = $button.text();
      $button.text('Loading...');
      
      offset += 6;
      posts.getRecent(baseUrl, {
        num: 6,
        offset: offset,
        category: extra.categoryId,
        include_ads: isMobile
      }, function(content) {
        var d = document.createElement('div');
        d.innerHTML = content;
        $('.inertia-home-articles-desc').append(d.children);
        ads.initFragment($(content), isMobile);
        $button.text(originalText);
      });
    });
  },

  /**
   * Single pages (photo, text, etc).
   */
  single: function(baseUrl, isMobile, extra) {
    var containerEl = $('#inertia-main-' + extra.post_id);
    util.resizeIframes();

    var gallery = containerEl.find('.inertia-gallery');
    var navOffset = 10
    var stickyHeader = true;

    if(stickyHeader) {
      $('.navbar-default').affix({
        offset: {
          top: function() {
            return parseInt($(document.body).css('paddingTop'), 10) + 25;
          }
        }
      });
    }

    if (!isMobile && !stickyHeader) {
      var contentNav = containerEl.find('.inertia-nav-content');
      var pageNav = $('.inertia-nav > .navbar');
      var visCls = 'visible';
      navOffset = 60;
      var pageHeader = containerEl.find('.page-header');
      if (pageHeader.length) {
        util.scrollWatcher(pageHeader, 0, function (eventType, event) {
          switch (eventType) {
            case 'enter':
              contentNav.removeClass(visCls);
              pageNav.addClass(visCls);
              break;

            case 'exit':
              if (!event.isBelowViewport) {
                contentNav.addClass(visCls);
                pageNav.removeClass(visCls);
              }
              break;
          }
        });
      }
    }

    //-- Custom Anchor Link JS --// 
    const anchorLinks = document.querySelectorAll('a[href^="#"]');  // Get all anchor links

    // Attach click event to each anchor link
    anchorLinks.forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();

            // Get the target element by its ID (the anchor href without the '#')
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                // Calculate the position of the target element minus 50px
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navOffset;

                // Scroll to the target position which accounts for sticky nav bar on top
                window.scrollTo({
                    top: targetPosition
                });
            }
        });
    });
    
    carousel(containerEl.find('.carousel'), {
      interval: false,
      callback: function(e) {
        if (historyApi.isAvailable) {
          var pid = $(e.target).find('.active img').data('pid');
          var queryParam = historyApi.getQueryObject();
          queryParam['pid'] = pid;
          historyApi.pushQueryParam(queryParam);
        }

        analytics.pageView();
        gallery.trigger('mouseenter');
      }
    });

    gallery.hover(function() {
      var controls = $(this).find('.carousel-control');
      var el = $(this).find('.active .carousel-caption');
      if (el.length) {
        el.animate({
          'height': el[0].scrollHeight + 5
        });
      } else {
        controls.width(39);
      }
    }, function() {
      var el = $(this).find('.active .carousel-caption');
      if (el.length) {
        el.animate({
          'height': '0'
        });
      } else {
        controls.width('45%');
      }
    });

    var firstItem = gallery.find('.item').first()[0];
    gallery.on('slide.bs.carousel', function (event) {
      var isLastTarget = event.relatedTarget === firstItem;
      if (event.direction === 'left' && isLastTarget) {
        var nextUrl = gallery.data('nexturl');
        if (nextUrl) {
          window.location.href = nextUrl;
        }
      }
    });

    var mobileInlineAd = containerEl.find('#ti-inline-ad');
    if (mobileInlineAd.length) {
      ads.inline(mobileInlineAd[0]);
    }

    var affixedMobileAd = containerEl.find('.inertia-ad-320x50');
    var replacedAffixedAd = false;
    if (affixedMobileAd.length) {
      var commentsContainer = containerEl.find('.inertia-comments-container');
      if (commentsContainer.length) {
        util.scrollWatcher(commentsContainer, 0, function (eventType) {
          if (eventType !== 'enter' || replacedAffixedAd) {
            return;
          }

          replacedAffixedAd = true;
          affixedMobileAd.animate({bottom: '-50px'}, 400, function () {
            containerEl.find('.popover-article').show().animate({
              bottom: 0
            }, 400)
          });
        });
      }
    }

    /*
    var aside = containerEl.find('aside');
    var affixedDesktopAd = aside.find('.inertia-ad-300x250');
    var article = containerEl.find('article');
    if (affixedDesktopAd.length && article.height() > 850) {
      var commentsContainer = containerEl.find('.inertia-comments-container');
      affixedDesktopAd.affix({
        offset: {
          top: function () {
            var top = affixedDesktopAd.prev().offset().top + affixedDesktopAd.prev().outerHeight(true) - 52;
            return top;
          },
          bottom: function () {
            var bottom = $(document).height() - commentsContainer.offset().top;
            return bottom;
          }
        }
      });
    }
    */

    if (!util.isUARobot() && !extra.isPicoEnabled) {
      posts.articleLoader(
        $('#inertia-main-' + extra.post_id + ' .inertia-newsletter-home'),
        $('#inertia-main-' + extra.post_id),
        extra.post_id,
        baseUrl,
        isMobile,
        pages.single
      );
    }

    if (!extra.isPicoEnabled) {
      comments(extra.post_id, extra.fullUrl, isMobile);
    }
  },

  singlePostLoad: function(baseUrl, isMobile, extra) {
    if (extra.isPicoEnabled) {
      if (extra.isSignedIn) {
        comments(extra.post_id, extra.fullUrl, isMobile);
      } else {
        document.querySelector('.inertia-comments-container').style.display = 'none';
      }
    }
  },

  /** Nada going on here */
  author: function(baseUrl, isMobile, extra) {},

  /**
   * Home a bit complex atm. Needs refactor.
   */
  home: function(baseUrl, isMobile, extra) {
    if (!isMobile) {
      carousel($('.carousel'), {
        interval: 5000
      });

      // Initialize video player immediately
      maybeLoadPlayer();

      var offset = 9;
      $('.inertia-load-more').click(function () {
        var $button = $(this);
        var originalText = $button.text();
        $button.text('Loading...');
        
        posts.getRecent(baseUrl, {num: 6, offset: offset}, function(content) {
          var d = document.createElement('div');
          d.innerHTML = content;
          $('.inertia-home-articles-desc').append(d.children);
          $button.text(originalText);
        });
        offset += 6;
      });
    } else {
      var maxScrolls = isMobile ? 3 : 5;
      var fetchedDocs = isMobile ? 1 : 2;

      endless.scrollerRecent(baseUrl, maxScrolls, fetchedDocs, {
        curated_list: !isMobile,
        exclude_ids: $('.inertia-endless-articles').data('exclude_ids') || [],
        include_ads: isMobile
      }, function (content) {
        ads.initFragment($(content), isMobile);
      });
    }

    $('.navbar-default').affix({
      offset: {
        top: function() {
          return parseInt($(document.body).css('paddingTop'), 10) + 25;
        }
      }
    });

    $('body img').on('error', function () {
      var src = $(this).attr('src');
      if (/^https:\/\/cdn1/.test(src)) {
        $(this).attr('src', src.replace('https://cdn1', 'https://www'));
      }
    });
  },

  search: function(baseUrl, isMobile, extra) {},
  archive: function(baseUrl, isMobile, extra) {},
  page: function(baseUrl, isMobile, extra) {},

  /**
   * All things
   */
  all: function(baseUrl, isMobile, extra) {
    nav.secondaryNav();
    newsletterModal.maybeLaunch();
    ads.init(extra.post_id || extra.categoryId || extra.dbId, false, isMobile);
  }
};

module.exports = pages;

